import { ComponentsFields } from './ComponentsFields';

export function DevForms() {
  return (
    <div>
      <h4>Fields:</h4>
      <ComponentsFields />
    </div>
  );
}
